import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import useCredentials from '../../../model/useCredentials';
import useEditing from '../../../model/useEditing';
import useUser from '../../../model/useUser';
import { UserService } from '../../../support/services/api';
import Data from './components/Data';
import SaveButton from './components/SaveButton';
import Header from './components/Header';
import EditImage from './components/EditImage';

import './styles.css';

export default function UserData() {
  const { sharedStates: credentialStates } = useCredentials();
  const { sharedStates: editStates, commands: editCommands } = useEditing();

  const {
    data: userData, isLoading, isIdle, isFetching,
  } = useQuery(
    ['user', credentialStates.userId],
    () => UserService().getByIds([credentialStates.userId]),
    {
      keepPreviousData: true,
      enabled: !!credentialStates.userId,
      select: (data) => (data.length ? data[0] : undefined),
    },
  );

  const { sharedStates: userStates, commands: userCommands, queries, metaStates: userMetaStates } = useUser(userData);

  useEffect(() => {
    if (!(isLoading || isIdle || isFetching)) {
      userCommands.changeUserData('multiple', {
        email: userData?.email,
        cpf: userData?.cpf,
        firstName: userData?.firstName,
        lastName: userData?.lastName,
        whatsapp: userData?.whatsapp,
        nickname: userData?.userName,
        img: userData?.imagesPaths?.length ? userData?.imagesPaths[userData?.imagesPaths.length - 1] : undefined,
      });
    }
  }, [userData]);

  return (
    <>
      <EditImage sharedStates={editStates} commands={{ ...userCommands, ...editCommands }} />
      <div className="page-container">
        <Header
          remoteStates={{ user: userData }}
          metaStates={{ isLoading, isIdle, isFetching }}
        />
        <Data
          metaStates={{ isLoading, isIdle, isFetching }}
          commands={{ user: userCommands, edit: editCommands }}
          sharedStates={{ user: userStates, edit: editStates }}
          remoteStates={{ user: userData }}
        />
        <SaveButton
          remoteStates={{ user: userData }}
          metaStates={{ isLoading, isIdle, isFetching, ...userMetaStates }}
          sharedStates={{ user: userStates, edit: editStates }}
          queries={queries}
          commands={{ user: userCommands, edit: editCommands }}
        />
      </div>
    </>
  );
}
